// src/apis/materialOutboundApi.ts
// PDA1070_R01 자재출고 API

import config from "../config";
import { ResponseDto } from "../dtos/common/responseDto";
import { getData, postData, patchData } from "../utils/axios/serverHelper";
import type {
  PDA1070_R01SearchParams,
  PDA1070_R01HeaderDto,
  PDA1070_R01Dto,
  PDA1070_R01BomLotDto,
  PDA1070_R01MaterialIssueRequest,
} from "src/containers/PDA/PDA1070_R01/PDA1070_R01Dto";

const baseUrl = `${config.apiUrl}/PDA1070_R01`;

// ========== 목록 화면 ==========

/**
 * 작업지시 목록 조회 (검색)
 */
export const searchWorkOrders = async (params?: PDA1070_R01SearchParams) => {
  const url = `${baseUrl}/search`;
  return await getData<ResponseDto<PDA1070_R01HeaderDto[]>>(url, { params });
};

/**
 * 작업지시 목록 조회 (새로고침)
 */
export const refetchWorkOrders = async (params?: PDA1070_R01SearchParams) => {
  const url = `${baseUrl}/refetch`;
  return await getData<ResponseDto<PDA1070_R01HeaderDto[]>>(url, { params });
};

// ========== 상세 화면 ==========

/**
 * LOT 스캔 검증 (조회만, 저장 안 함)
 */
export const validateScannedLot = async (
  productWorkNo: string,
  lotNo: string
) => {
  const url = `${baseUrl}/validate-lot/${encodeURIComponent(productWorkNo)}/${encodeURIComponent(lotNo)}`;
  return await getData<ResponseDto<PDA1070_R01BomLotDto>>(url);
};

/**
 * 작업지시 상세 + BOM 자재별 LOT 목록
 */
export const getWorkOrderDetail = async (
  productWorkNo: string,
  warehouseCd?: string
) => {
  const url = `${baseUrl}/work/${productWorkNo}`;
  return await getData<ResponseDto<PDA1070_R01Dto>>(url, {
    params: warehouseCd ? { warehouseCd } : undefined,
  });
};

// ========== 출고 등록/수정 ==========

/**
 * 자재 출고 등록
 */
export const createMaterialIssue = async (
  request: PDA1070_R01MaterialIssueRequest
) => {
  const url = `${baseUrl}`;
  return await postData<
    PDA1070_R01MaterialIssueRequest,
    ResponseDto<string>
  >(url, request);
};

/**
 * 자재 출고 수정 (추가 출고)
 */
export const updateMaterialIssue = async (
  request: PDA1070_R01MaterialIssueRequest
) => {
  const url = `${baseUrl}`;
  return await patchData<
    PDA1070_R01MaterialIssueRequest,
    ResponseDto<string>
  >(url, request);
};
